import React from 'react'

import Accordion from '../../molecules/Accordion'
import Alert from '../../molecules/Alert'
import CalculatorDetails from '../../molecules/CalculatorDetails'
import Callout from '../../molecules/Callout'
import Card from '../../molecules/Card'
import ChartsContainer from '../../molecules/ChartsContainer'
import FeatureBlock from '../../molecules/Feature'
import FormsAndTransactions from '../../molecules/FormsAndTransaction'
import HeroBanner from '../../molecules/HeroBanner'
import IconListBlock from '../../molecules/IconListBlock'
import Performances from '../../molecules/Performances'
import Podcast from '../../molecules/Podcast'
import QuickLinkscomponent from '../../molecules/QuickLinks'
import ReportSignificantDealingsForm from '../../molecules/ReportSignificantDealingsForm'
import SocialMedia from '../../molecules/SocialMedia'
import Tabs from '../../molecules/Tabs'
import TextBlock from '../../molecules/TextBlock'
import TwoColumnArticle from '../../molecules/TwoColumnArticle'
import ContactUsForm from '../ContactUsForm'
import DailyUnitPrice from '../DailyUnitPrice'
import EventRegistrationForm from '../EventRegistrationForm'
import Events from '../Events'
import NewsBlock from '../NewsBlock'
import PageBanner from '../PageBanner'
import PlannedRetirementForm from '../PlannedRetirement'
import FeatureBlockWithImage from '../feature-block/FeatureBlockWithImage'

interface DynamicProps {
  components: any
}
/**
 * Dynamic Component
 * @param components - Content from the CMS.
 */
const DynamicComponent = ({ components }: DynamicProps) => {
  return (
    <>
      {components?.fields?.pageContainer?.map((component, index) => (
        <div key={`${component?.sys?.contentType?.sys?.id}-${index}`}>
          {/* Hero Banner component Starts */}
          {component?.sys?.contentType?.sys?.id === 'heroBannerComponent' && (
            <HeroBanner content={component?.fields} isArticle={components.fields?.articlePag} />
          )}
          {/* Hero Banner component Ends */}

          {/* Contact us form component Starts */}
          {component?.sys?.contentType?.sys?.id === 'login' && <ContactUsForm />}
          {/* Contact us form component Ends */}

          {/* Report Significant Dealings form component Starts */}
          {component?.sys?.contentType?.sys?.id === 'reportSignificantDealingsForm' && (
            <ReportSignificantDealingsForm />
          )}
          {/* Report Significant Dealings form component Ends */}

          {/* Event Registration form component Starts */}
          {component?.sys?.contentType?.sys?.id === 'eventRegistrationForm' && <EventRegistrationForm />}
          {/* Event Registration form component Ends */}

          {/* Planned Retirement form component Starts */}
          {component?.sys?.contentType?.sys?.id === 'yourPlannedRetirementDateForm' && <PlannedRetirementForm />}
          {/* Planned Retirement form component Ends */}

          {/* News component Starts */}
          {component?.sys?.contentType?.sys?.id === 'newsContainer' && (
            <NewsBlock content={component?.fields} parentSlug={components.slug} />
          )}
          {/* News component Ends */}

          {/* Calculators component Starts */}
          {component?.sys?.contentType?.sys?.id === 'calculators' && <CalculatorDetails content={component?.fields} />}
          {/* Calculators component Ends */}

          {/* dailyUnitPrice component Starts */}
          {component?.sys?.contentType?.sys?.id === 'dailyUnitPrice' && <DailyUnitPrice content={component?.fields} />}
          {/* dailyUnitPrice component Ends */}

          {/* Performances component Starts */}
          {component?.sys?.contentType?.sys?.id === 'performances' && <Performances content={component?.fields} />}
          {/* Performances component Ends */}

          {/* Two Columns Article component Starts */}
          {component?.sys?.contentType?.sys?.id === 'twoColumnsArticleBlock' && (
            <TwoColumnArticle content={component?.fields} isArticle={components?.fields?.articlePage} />
          )}
          {/* Two Columns Article component Ends */}

          {/* Page Banner component Starts */}
          {component?.sys?.contentType?.sys?.id === 'pageBanner' && (
            <PageBanner
              content={component?.fields}
              background={component?.fields.backgroundVariantColor}
              breadcrumb={components?.fields}
              isArticle={components?.fields?.articlePage}
            />
          )}
          {/* Page Banner component Ends */}

          {/* Page Alert Starts */}
          {component?.sys?.contentType?.sys?.id === 'notification' && (
            <Alert content={component} background={component?.fields.backgroundColor} />
          )}
          {/* Page Alert Ends */}

          {/* Rich Text component Starts */}
          {component?.sys?.contentType?.sys?.id === 'contentComponent' && (
            <TextBlock content={component?.fields} isArticle={components?.fields?.articlePage} />
          )}
          {/* Rich Text component Ends */}

          {/* Events component Ends */}
          {component?.sys?.contentType?.sys?.id === 'eventsBlock' && <Events content={component?.fields} />}
          {/* Events component Ends */}

          {/* QuickLinks, Text component, Forms&Transaction & Cards component Starts */}
          {component?.sys?.contentType?.sys?.id === 'blockInfoComponent' && (
            <>
              {component?.fields?.features ? (
                <>
                  {component?.fields?.features[0]?.sys?.contentType?.sys?.id === 'bunchOfLinksComponents' && (
                    <QuickLinkscomponent content={component?.fields} />
                  )}
                  {component?.fields?.features[0]?.sys?.contentType?.sys?.id === 'iconList' && (
                    <IconListBlock content={component?.fields} isArticle={components?.fields?.articlePage} />
                  )}
                  {component?.fields?.features[0]?.sys?.contentType?.sys?.id === 'charts' && (
                    <ChartsContainer
                      content={component?.fields}
                      background={component?.fields?.sectionBackgroundColor}
                      isArticle={components?.fields?.articlePage}
                    />
                  )}
                  {component?.fields?.features[0]?.sys?.contentType?.sys?.id === 'blockInfoFeatureComponent' && (
                    <>
                      {!component?.fields?.callOut && (
                        <Card
                          background={component?.fields?.sectionBackgroundColor}
                          cardBackground={component?.fields?.cardBackgroundColor}
                          columnLayout={component?.fields?.cardLayout}
                          border={component?.fields?.cardBorder}
                          content={component?.fields}
                          marginBottom={component?.fields?.componentSpacing}
                          isArticle={components?.fields?.articlePage}
                        />
                      )}
                      {component?.fields?.callOut && (
                        <Callout
                          background={component?.fields?.sectionBackgroundColor}
                          content={component?.fields}
                          textAlignment={component?.fields?.cardTextAlign}
                          marginBottom={component?.fields?.componentSpacing}
                        />
                      )}
                    </>
                  )}
                  {component?.fields?.features[0]?.sys?.contentType?.sys?.id === 'ctaButtonComponent' && (
                    <TextBlock
                      content={component?.fields}
                      background={component?.fields?.sectionBackgroundColor}
                      marginBottom={component?.fields?.componentSpacing}
                      isArticle={components?.fields?.articlePage}
                    />
                  )}
                  {component?.fields?.features[0]?.sys?.contentType?.sys?.id === 'pdfCardComponent' && (
                    <FormsAndTransactions content={component?.fields} />
                  )}
                  {component?.fields?.features[0]?.sys?.contentType?.sys?.id === 'socialMedia' && (
                    <SocialMedia content={component?.fields} isArticle={components?.fields?.articlePage} />
                  )}
                  {component?.fields?.features[0]?.sys?.contentType?.sys?.id === 'tabContainerComponent' && (
                    <>
                      {component?.fields?.componentType === 'Tabs' && (
                        <Tabs
                          content={component?.fields}
                          border={component?.fields?.cardBorder}
                          background={component?.fields?.sectionBackgroundColor}
                          isArticle={components?.fields?.articlePage}
                        />
                      )}
                      {component?.fields?.componentType === 'TabSelector' && (
                        <Tabs
                          content={component?.fields}
                          border={component?.fields?.cardBorder}
                          background={component?.fields?.sectionBackgroundColor}
                          isArticle={components?.fields?.articlePage}
                        />
                      )}
                    </>
                  )}
                  {component?.fields?.features[0]?.sys?.contentType?.sys?.id === 'podcast' && (
                    <Podcast content={component?.fields} isArticle={components?.fields?.articlePage} />
                  )}
                </>
              ) : (
                <>
                  {component?.fields?.assets ? (
                    <>
                      {!component?.fields?.callOut && (
                        <Card
                          background={component?.fields?.sectionBackgroundColor}
                          cardBackground={component?.fields?.cardBackgroundColor}
                          columnLayout={component?.fields?.cardLayout}
                          border={component?.fields?.cardBorder}
                          content={component?.fields}
                          marginBottom={component?.fields?.componentSpacing}
                          isArticle={components?.fields?.articlePage}
                        />
                      )}
                      {component?.fields?.callOut && (
                        <Callout
                          background={component?.fields?.sectionBackgroundColor}
                          content={component?.fields}
                          textAlignment={component?.fields?.cardTextAlign}
                          marginBottom={component?.fields?.componentSpacing}
                        />
                      )}
                    </>
                  ) : (
                    <>
                      <TextBlock
                        content={component?.fields}
                        background={component?.fields?.sectionBackgroundColor}
                        marginBottom={component?.fields?.componentSpacing}
                        isArticle={components?.fields?.articlePage}
                      />
                    </>
                  )}
                </>
              )}
            </>
          )}
          {/* QuickLinks, Text component, Forms&Transaction & Cards component Ends */}

          {/* Feature Block Starts */}
          {component?.sys?.contentType?.sys?.id === 'contentWithCtaComponent' && (
            <>
              {component?.fields?.variant === 'text' && (
                <FeatureBlock
                  variant="text"
                  background={component?.fields?.backgroundColor}
                  content={component?.fields}
                />
              )}
              {component?.fields?.variant === 'appStore' && (
                <FeatureBlock
                  variant="appStore"
                  background={component?.fields?.backgroundColor}
                  content={component?.fields}
                />
              )}
            </>
          )}
          {component?.sys?.contentType?.sys?.id === 'doubleBarreledComponent' && (
            <FeatureBlockWithImage
              variant={component.fields?.columnLayoutVariant === 'Image on the Left Col' ? 'image-left' : 'image-right'}
              {...component.fields}
            />
          )}
          {/* Feature Block Ends */}

          {/* Charts */}
          {component?.sys?.contentType?.sys?.id === 'charts' && (
            <>
              <ChartsContainer
                content={component?.fields}
                background={component?.fields?.sectionBackgroundColor}
                isArticle={components?.fields?.articlePage}
              />
            </>
          )}
          {/* Accordions */}
          {component?.sys?.contentType?.sys?.id === 'accordionContainer' && <Accordion content={component?.fields} />}
        </div>
      ))}
    </>
  )
}

export default DynamicComponent
